import { Injectable } from '@angular/core';
import { Observable,Subject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { BankProfile } from '../utils/bank-profile';
import { BankAccountValidationRequest } from '../utils/bank-account-validation-request';
import {environment} from '../../../environments/environment'
import { InvoicePayment } from '../utils/invoice-payment';
import { PaymentPayload } from '../utils/payload';
import { ExtendedPaymentUpdateTransaction } from '../utils/extended-payment-update-transaction';
import { PaymentRetractTransaction } from '../utils/payment-retract-transaction';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
 

  //BASE_URL="http://localhost:8081/api/";
  BASE_URL = 'https://dtfs-stg.daimler-truckfinancial.com/services/';
  //BASE_URL="/opsservices/api/";
  BASE_URL_MANAGEBANKPROFILE="bankProfile/v1/"
  BASE_URL_ONLINE_PAYMENT="onlinePayment/v1/"
  BASE_URL_RECURRING_PAYMENT="recurringPayment/v1/"
  BASE_URL_STATEMENT_PAYMENT="statementPayment/v1/"
  BASE_URL_PRINCIPAL_PAYMENT= "principalPayment/v1/";
  BASE_URL_PAYMENT = "payment/v1/"
  BASE_URL_ONLINE_PAYMENT_HISTORY="onlinePaymentHistory/v1/"
  BASE_URL_STATEMENT_PAYMENT_HISTORY="statementPaymentHistory/v1/"
  BASE_URL_RECURRING_PAYMENT_HISTORY="recurringPaymentHistory/v1/"
  BASE_URL_USERACCOUNT="userAccountInfo/v1/"
  // requestHeaders=new HttpHeaders()
  // .append('userId','test5002104231001')
  // .append('cCANNumber','0000031100')
  // .append('userdcsAccount','5002104231001');
  // .append('Access-Control-Allow-Origin', 'http://localhost:8081');

  constructor(private http:HttpClient) {
  }

  getRequest(URL:any):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_MANAGEBANKPROFILE+URL);
  }

  getBankProfile(URL: any):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_MANAGEBANKPROFILE+URL,{ responseType: "text"});
  }

  postRequest(requestBody: BankProfile, URL: String){
    return this.http.post(this.BASE_URL+this.BASE_URL_MANAGEBANKPROFILE+URL, requestBody);
  }

  postRequestForValidation(requestBody:BankProfile, URL: String){
    return this.http.post(this.BASE_URL+this.BASE_URL_MANAGEBANKPROFILE+URL, requestBody);
  }

  putRequest(requestBody: BankProfile,URL: String){
    let userAccountInfo= JSON.parse(sessionStorage.getItem('userAccountInfo'))
    let bankAccountId=userAccountInfo.custName
    return this.http.put(this.BASE_URL+this.BASE_URL_MANAGEBANKPROFILE+URL, requestBody,{ headers: {"bankAccountId":bankAccountId} });
  }

  deleteRequest(URL: String, requestBody: BankProfile):Observable<any>{
    return this.http.delete(this.BASE_URL+this.BASE_URL_MANAGEBANKPROFILE+URL,{body: requestBody});
  }

  // Local JSON File integratiom
  public getJSON(url:any): Observable<any> {
    return this.http.get(url);
}

  getBankProfileList(URL: any, header):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_PAYMENT+URL ,{headers:header});
  }
  
  getAccountsList(URL: any):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_PAYMENT+URL);
  }

  getInvoiceAccountsList(URL: any):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_STATEMENT_PAYMENT+URL);
  }

  validateStatementPayment(URL: any, requestBody: InvoicePayment[]){
    return this.http.post(this.BASE_URL+this.BASE_URL_STATEMENT_PAYMENT+URL, requestBody);
  }

  validateRecurringPayment(URL: any, requestBody: PaymentPayload[], header){
    return this.http.post(this.BASE_URL+this.BASE_URL_RECURRING_PAYMENT+URL, requestBody,{headers:header});
  }

  insertStatementPayment(URL: any, requestBody: InvoicePayment[]){
    return this.http.post(this.BASE_URL+this.BASE_URL_STATEMENT_PAYMENT+URL, requestBody);
  }

  insertRecurringPayment(URL: any, requestBody: PaymentPayload[],header){
    return this.http.post(this.BASE_URL+this.BASE_URL_RECURRING_PAYMENT+URL, requestBody,{headers:header});
  }

  validateOnlinePayment(requestBody:any, URL: String){
    return this.http.post(this.BASE_URL+this.BASE_URL_ONLINE_PAYMENT+URL,requestBody);
  }
  validateOnlinePaymentHistory(requestBody:any, URL: String, header){
    return this.http.post(this.BASE_URL+this.BASE_URL_ONLINE_PAYMENT_HISTORY+URL,requestBody,{headers:header});
  }
  makePrincipalPayment(requestBody, URL){
    return this.http.post(this.BASE_URL+this.BASE_URL_PRINCIPAL_PAYMENT+URL,requestBody);
  }
  makeOnlinePayment(requestBody, URL){
    return this.http.post(this.BASE_URL+this.BASE_URL_ONLINE_PAYMENT+URL,requestBody);
  }

  getRecurringHistoryDetails(URL) :Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_RECURRING_PAYMENT_HISTORY+URL);
  }
  updateRecurringDetails(requestBody,URL){
    return this.http.put(this.BASE_URL+this.BASE_URL_RECURRING_PAYMENT_HISTORY+URL, requestBody);
  }
  getStatmentHistoryDetails(URL: any):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_STATEMENT_PAYMENT_HISTORY+URL);
  }
  deleteRecurringDetails(requestBody,URL):Observable<any>{
    return this.http.delete(this.BASE_URL+this.BASE_URL_RECURRING_PAYMENT_HISTORY+URL,{body: requestBody});
  }

  getOnlineTransactionHistory(URL: any):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_ONLINE_PAYMENT_HISTORY+URL);
  }
 
  viewOnlineTransactionHistory(URL: any):Observable<any>{
    return this.http.get(this.BASE_URL+this.BASE_URL_ONLINE_PAYMENT+URL);
  }
 
  updateOnlinePaymentTransaction(URL: String, requestBody: ExtendedPaymentUpdateTransaction){
    return this.http.put(this.BASE_URL+this.BASE_URL_ONLINE_PAYMENT_HISTORY+URL, requestBody);
  }
 
  deleteOnlinePaymentTransaction(URL: String, requestBody: PaymentRetractTransaction):Observable<any>{
    return this.http.delete(this.BASE_URL+this.BASE_URL_ONLINE_PAYMENT_HISTORY+URL,{body: requestBody});
  }
  descryptvalue(requestBody,URL){
    return this.http.post(this.BASE_URL+this.BASE_URL_PAYMENT+URL,requestBody);
  }

  getUserInfo(URL){
    return this.http.get(this.BASE_URL+this.BASE_URL_USERACCOUNT+URL);
  }
}
